import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Container, DropdownToggle } from "reactstrap";
import uuid from "uuid";

import UserDropdownModal from "../SuperAdmin/Header/UserDropdownModal";

import logo from "ASSETS/Images/img_header_logo.webp";
import "./Header.less";
import {
  getUserNameAcronym,
  getUserNameForSelectedLanguage,
  removeTrailingSlash,
} from "../../Utils/Utility";
import { USER_ROLES, APP_CONFIG, CONFIG } from "UTILS/Constants";

import { func, string } from "prop-types";

class Header extends Component {
  static propTypes = {
    handleLogout: func,
    userName: string,
    userRole: string
  };
  state = {
    showUserInfoModal: false
  };

  getUserLogo = () => {
    let userName = getUserNameForSelectedLanguage(this.props.language, 
      this.props.userProfileData.first_name + ' ' + (this.props.userProfileData.last_name ? this.props.userProfileData.last_name :''));
    return (
      <DropdownToggle className="dropdownToggleButton mr-3 pr-0" onClick={this.toggle}>
        {" "}
        <span className="displayFlex alignItemsCenter justifyContentFlexCenter card-text noPadding" key={uuid.v4()}>
          {getUserNameAcronym(userName)}
        </span>
      </DropdownToggle>
    );
  };

  toggle = () => {
    this.setState({
      showUserInfoModal: !this.state.showUserInfoModal
    });
  };

  render() {
    return (
      <section className="header createSessionHeader">
        <Container className="pl-lg-0">
          <Row className="alignItemsCenter">
            <Col lg="8" md="8" xs="9" className="headerLogoContainer">
              <div className="logoHeaderDiv">
                <img className="logoHeader" src={this.props.logoUrl ? this.props.logoUrl : logo} />
              </div>
            </Col>
            {(this.props.userRole === USER_ROLES.AGENT ||
              this.props.userRole === USER_ROLES.SUPER_ADMIN ||
              this.props.userRole === USER_ROLES.ADMIN) &&
              removeTrailingSlash(this.props.location.pathname) !== CONFIG.path.sessionEndScreen &&
              removeTrailingSlash(this.props.location.pathname) !== CONFIG.path.callWaiting && (
              <Col lg="4" md="4" xs="3" className="text-right">
                <div>
                  <UserDropdownModal
                    show={this.state.showUserInfoModal}
                    userIcon={this.getUserLogo()}
                    toggle={this.toggle}
                    handleLogoutClick={this.props.handleLogout}
                    userProfileData={this.props.userProfileData}
                    handleUpdateProfileClick={this.props.handleUpdateProfileClick}
                    toggleChangePasswordModal={this.props.toggleChangePasswordModal}
                    showChangePasswordModal={this.props.showChangePasswordModal}
                    role={this.props.userRole}
                    isSSOLogin={this.props.isSSOLogin}
                    language={this.props.language}
                    lastLoginDate={this.props.lastLoginDate}
                  />
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    );
  }
}

export default withRouter(Header);
